/* global swal, _, angular*/
import './style.less';

export default function($log) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  function getTile(status = 0) {
    if (status === -1) {
      return {
        color: 'label-danger',
        text: 'Exempt'
      };
    }
    if (status === 0) {
      return {
        color: 'label-default',
        text: 'No Progress'
      };
    }
    if (status < 1) {
      return {
        color: 'label-warning',
        text: 'In Progress'
      };
    }
    return {
      color: 'label-success',
      text: 'Completed'
    };
  }

  function activate() {
    $log.debug('Progress Tile Component Activated');
    vm.tile = getTile(vm.ngModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/progressTIle/controller.js